<script setup>
import { defineProps } from "vue";

const props = defineProps({
  rating: {
    type: Number,
    required: true,
  },
  indexpath: {
    type: Number,
    default: 1,
  },
  size: {
    type: Number,
    default: 24,
  },
});

const getFillPercentage = (index) => {
  const fullStars = Math.floor(props.rating);
  const remainder = props.rating - fullStars;

  if (index < fullStars) {
    return "100%";
  } else if (index === fullStars) {
    return `${remainder * 100}%`;
  }
  return "0%";
};
</script>

<template>
  <div class="stars">
    <svg
      v-for="(star, index) in 5"
      :key="index"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      class="star"
    >
      <defs>
        <linearGradient :id="'grad' + index + props.indexpath">
          <stop offset="0%" stop-color="#806de5" />
          <stop :offset="getFillPercentage(index)" stop-color="#806de5" />
          <stop :offset="getFillPercentage(index)" stop-color="#ccc" />
          <stop offset="100%" stop-color="#ccc" />
        </linearGradient>
      </defs>
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.77 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"
        :fill="'url(#grad' + index + props.indexpath + ')'"
      />
    </svg>
  </div>
</template>


  <style scoped>
.stars {
  display: flex;
  height: max-content;
}

.star {
  transition: all 0.3s ease;
}
</style>
  